import { createContext, type MouseEvent, type RefObject, useContext } from "react";
import type { Chat } from "../utils/models";

type UserGuideChatContextType = {
	chats: Chat[];
	allConversations: Chat[];
	activeChat: Chat | undefined;
	activeChatId: string | null;
	isOpen: boolean;
	isHiding: boolean;
	changeHideStatus: (openStatus: boolean) => void;
	isDrawerOpen: boolean;
	messageEndRefs: RefObject<Record<string, HTMLDivElement | null>>;
	updateChat: (chatId: string, updates: Partial<Chat>) => void;
	handleSendMessage: (chatId: string) => (e: React.FormEvent) => void;
	handleToggleChat: () => void;
	handleNewChat: () => void;
	handleSwitchChat: (chatId: string) => void;
	handleDeleteChat: (chatId: string, e?: MouseEvent) => void;
	setIsDrawerOpen: (open: boolean) => void;
	getChatTitle: (chat: Chat) => string;
	isDeletingConversation: boolean;
	isLoadingAllConversations: boolean;
};

export const UserGuideChatContext = createContext<UserGuideChatContextType | undefined>(undefined);

export const useUserGuideChat = () => {
	const context = useContext(UserGuideChatContext);
	if (!context) throw new Error("useUserGuideChat must be used within UserGuideChatProvider");

	return context;
};
